import type * as React from 'react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

import { useTheme } from '@/components/theme-provider'

/**
 * App-wide toast host. Follows the active app theme (light/dark/system).
 * Render once near the root (see main.tsx). Trigger toasts via `toast` from `sonner`.
 */
function Toaster({ ...props }: ToasterProps) {
  const { theme } = useTheme()
  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
